import React from 'react';
import { connect } from "react-redux";
import { toast } from "react-toastify";
import moment from 'moment';
import { Doughnut, Bar } from 'react-chartjs-2';
import {
  Row, Col, Card, Statistic, Button, Input, Select,
  Modal, Table, Badge, Spin, List, Typography, Space, Avatar
} from 'antd';
import { FilterOutlined, ClearOutlined } from '@ant-design/icons';

import DashboardServices from "../../services/dashboard";
import './styles.css';
import Notificacoes from '../../components/Notificacoes';

const { Title, Text } = Typography;
const { Option } = Select;


// Mapeamento de etapas conhecidas para cada grupo macro
const GRUPOS_MACRO = [
  {
    grupo: 'Criação', icone: 'fa-pencil', cor: '#3b82f6',
    palavrasChave: ['start do contrato', 'briefing', 'cadastro de formandos', 'boas vindas', 'roteiro do convite']
  },
  {
    grupo: 'Design', icone: 'fa-paint-brush', cor: '#10b981',
    palavrasChave: ['publicação da capa dura', 'revisão da capa dura', 'publicação do convite', 'revisão do convite']
  },
  {
    grupo: 'Aprovação', icone: 'fa-check-circle', cor: '#f59e0b',
    palavrasChave: ['republicação da capa dura', 'republicação capa dura', 'aprovação final da capa dura', 'aprovação da capa dura', 'liberação de bureau', 'liberação bureau', 'republicação do convite', 'aprovação final/qtd', 'finalização da etapa', 'atendimento designer online']
  },
  {
    grupo: 'Produção', icone: 'fa-cogs', cor: '#8b5cf6',
    palavrasChave: ['envio das fotos', 'conferência das fotos', 'início sistema de personalização', 'aprovação final da personalização', 'finalização do sistema de personalização']
  },
  {
    grupo: 'Entrega', icone: 'fa-truck', cor: '#dc2626',
    palavrasChave: ['saída da produção', 'saida da produção', 'entrega dos convites', 'pós vendas', 'pos vendas']
  }
];

function classificarEtapa(etapa) {
  const etapaLower = etapa.toLowerCase();
  for (const grupo of GRUPOS_MACRO) {
    if (grupo.palavrasChave.some(chave => etapaLower.includes(chave))) {
      return grupo.grupo;
    }
  }
  return null;
}

function montarPipeline(etapasDoBanco) {
  const gruposMap = {};
  GRUPOS_MACRO.forEach(g => {
    gruposMap[g.grupo] = { grupo: g.grupo, icone: g.icone, cor: g.cor, etapas: [] };
  });

  etapasDoBanco.forEach(etapa => {
    const grupo = classificarEtapa(etapa);
    if (grupo && gruposMap[grupo]) {
      gruposMap[grupo].etapas.push(etapa);
    }
  });

  // Retorna apenas grupos que possuem etapas
  const resultado = [];
  GRUPOS_MACRO.forEach(g => {
    if (gruposMap[g.grupo].etapas.length > 0) resultado.push(gruposMap[g.grupo]);
  });
  return resultado;
}
const DESIGNERS_PERMITIDOS = ['ADILSON-AT', 'NÍCOLAS', 'KAMILA', 'GEOVANE', 'LORRANA'];

class Dashboard extends React.Component {

  state = {
    loading: true,
    procedimentos: [],
    procedimentosLista: [],
    atendentes: [],
    pipeline: [],
    // Filtros
    dataInicio: '2021-01-01',
    filtroStatus: 'todos',
    filtroDesigner: '',
    filtroFormaturaDe: '',
    filtroFormaturaAte: '',
    filtroProcedimento: '',
    // modal lista de contratos
    detalheAberto: false,
    detalheLoading: false,
    detalheProcedimento: "",
    detalheContratos: [],
    detalhePagina: 1,
    detalhePorPagina: 10,
    detalheTipo: 'procedimento',
    filtros: { contrato: '', procedimento: '', atendente: '', entregaDe: '', formaturaDe: '' },
    // modal timeline
    timelineAberto: false,
    timelineLoading: false,
    timelineContrato: null,
    timelineProcedimentos: [],
    timelineRefeito: null,
    // grupos expandidos (acordeão)
    gruposAbertos: {},
    // busca contrato
    buscaContrato: '',
    buscandoContrato: false,
    // modal comentario
    comentarioAberto: false,
    comentarioLoading: false,
    comentarioProc: null,
    comentarios: [],
    novoComentario: '',
    salvandoComentario: false
  }

  async componentDidMount() {
    await this.carregarEtapas();
    this.carregarDashboard();
  }

  async carregarEtapas() {
    const dashboard = new DashboardServices();
    try {
      const resp = await dashboard.getEtapas();
      const etapas = resp.etapas || [];
      this.setState({ pipeline: montarPipeline(etapas) });
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao carregar etapas");
    }
  }

  getFiltrosAtivos() {
    return {
      formaturaDe: this.state.filtroFormaturaDe,
      formaturaAte: this.state.filtroFormaturaAte,
      designer: this.state.filtroDesigner
    };
  }

  async carregarDashboard() {
    const dashboard = new DashboardServices();
    this.setState({ loading: true });
    try {
      const filtros = this.getFiltrosAtivos();
      const [resp, respLista] = await Promise.all([
        dashboard.getProcedimentos(this.state.dataInicio, filtros),
        dashboard.getProcedimentosLista(this.state.dataInicio, filtros)
      ]);
      this.setState({
        procedimentos: resp.procedimentos || [],
        procedimentosLista: respLista.procedimentos || [],
        atendentes: (resp.atendentes || []).filter((d) => DESIGNERS_PERMITIDOS.includes(d)),
        loading: false
      });
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao carregar dados do dashboard");
      this.setState({ loading: false });
    }
  }

  aplicarFiltros() {
    this.carregarDashboard();
  }

  limparFiltros() {
    this.setState({
      filtroDesigner: '',
      filtroFormaturaDe: '',
      filtroFormaturaAte: '',
      filtroProcedimento: '',
      filtroStatus: 'todos',
      dataInicio: '2025-01-01'
    }, () => this.carregarDashboard());
  }

  async buscarContrato() {
    const { buscaContrato } = this.state;
    if (!buscaContrato.trim()) return;
    const dashboard = new DashboardServices();
    this.setState({ buscandoContrato: true });
    try {
      const resp = await dashboard.buscarContrato(buscaContrato.trim());
      const contratos = resp.contratos || [];
      if (contratos.length === 0) {
        toast.warn("Nenhum contrato encontrado");
      } else if (contratos.length === 1) {
        this.abrirTimeline(contratos[0].Codigo);
      } else {
        this.setState({
          detalheAberto: true, detalheLoading: false,
          detalheProcedimento: `Busca: ${buscaContrato}`,
          detalheContratos: contratos, detalhePagina: 1,
          filtros: { contrato: '', procedimento: '', atendente: '', entregaDe: '', formaturaDe: '' }
        });
      }
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao buscar contrato");
    }
    this.setState({ buscandoContrato: false });
  }

  async abrirDetalhe(procedimento) {
    const dashboard = new DashboardServices();
    this.setState({
      detalheAberto: true, detalheLoading: true, detalheTipo: 'procedimento',
      detalheProcedimento: procedimento, detalheContratos: [], detalhePagina: 1,
      filtros: { contrato: '', procedimento: '', atendente: '', entregaDe: '', formaturaDe: '' }
    });
    try {
      const resp = await dashboard.getDetalheProcedimento(procedimento, this.state.dataInicio, this.getFiltrosAtivos());
      this.setState({ detalheContratos: resp.contratos || [], detalheLoading: false });
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao carregar detalhes");
      this.setState({ detalheLoading: false });
    }
  }

  fecharDetalhe() {
    this.setState({ detalheAberto: false, detalheContratos: [], detalheProcedimento: "" });
  }

  async abrirTimeline(codigo) {
    const dashboard = new DashboardServices();
    this.setState({ timelineAberto: true, timelineLoading: true, timelineContrato: null, timelineProcedimentos: [] });
    try {
      const resp = await dashboard.getContratoTimeline(codigo);
      this.setState({
        timelineContrato: resp.contrato,
        timelineProcedimentos: resp.procedimentos || [],
        timelineRefeito: resp.refeito || null,
        timelineLoading: false
      });
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao carregar cronograma do contrato");
      this.setState({ timelineLoading: false });
    }
  }

  fecharTimeline() {
    this.setState({ timelineAberto: false, timelineContrato: null, timelineProcedimentos: [], timelineRefeito: null });
  }

  async abrirComentario(proc) {
    const dashboard = new DashboardServices();
    const contrato = this.state.timelineContrato ? this.state.timelineContrato.contrato : null;
    if (!proc.Registro || !contrato) return;
    this.setState({ comentarioAberto: true, comentarioLoading: true, comentarioProc: proc, comentarios: [], novoComentario: '' });
    try {
      const resp = await dashboard.getComentarios(proc.Registro, contrato);
      this.setState({ comentarios: resp.comentarios || [], comentarioLoading: false });
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao carregar comentários");
      this.setState({ comentarioLoading: false });
    }
  }

  fecharComentario() {
    this.setState({ comentarioAberto: false, comentarioProc: null, comentarios: [], novoComentario: '' });
  }

  async salvarComentario() {
    const { comentarioProc, novoComentario, timelineContrato } = this.state;
    if (!novoComentario.trim()) return;
    const dashboard = new DashboardServices();
    const usuario = this.props.usuario ? this.props.usuario.nome || this.props.usuario.email || '' : '';
    this.setState({ salvandoComentario: true });
    try {
      await dashboard.salvarComentario(comentarioProc.Registro, timelineContrato.contrato, novoComentario.trim(), usuario);
      toast.success("Comentário salvo");
      this.setState({ novoComentario: '' });
      const resp = await dashboard.getComentarios(comentarioProc.Registro, timelineContrato.contrato);
      this.setState({ comentarios: resp.comentarios || [], salvandoComentario: false });
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao salvar comentário");
      this.setState({ salvandoComentario: false });
    }
  }

  toggleGrupo(grupo) {
    this.setState(prev => ({
      gruposAbertos: { ...prev.gruposAbertos, [grupo]: !prev.gruposAbertos[grupo] }
    }));
  }

  atualizarFiltro(campo, valor) {
    this.setState({ filtros: { ...this.state.filtros, [campo]: valor }, detalhePagina: 1 });
  }

  isAbandonado(item) {
    const statusRaw = item ? (item.statusProc || item.Status || item.status || '') : '';
    const status = String(statusRaw)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
    return status.includes('abandonado');
  }

  filtrarContratos() {
    const { detalheContratos, filtros } = this.state;
    return detalheContratos.filter(c => {
      if (this.isAbandonado(c)) return false;
      if (filtros.contrato && !String(c.contrato || '').toLowerCase().includes(filtros.contrato.toLowerCase())) return false;
      if (filtros.procedimento && !String(c.procedimento || '').toLowerCase().includes(filtros.procedimento.toLowerCase())) return false;
      if (filtros.atendente && !(c.RegistradoPor || '').toLowerCase().includes(filtros.atendente.toLowerCase())) return false;
      if (filtros.entregaDe && c.dt_entrega && moment(c.dt_entrega).format('YYYY-MM-DD') < filtros.entregaDe) return false;
      if (filtros.formaturaDe && c.dt_formatura && moment(c.dt_formatura).format('YYYY-MM-DD') < filtros.formaturaDe) return false;
      return true;
    });
  }

  getStepClass(proc) {
    const status = (proc.Status || '').toLowerCase();
    if (proc.atrasado) return 'step-atrasado';
    if (status === 'concluido') return 'step-concluido';
    if (status === 'execução' || status === 'execucao') return 'step-execucao';
    return 'step-aguardando';
  }

  getStepLabel(proc) {
    const status = (proc.Status || '').toLowerCase();
    if (proc.atrasado) return 'Atrasado';
    if (status === 'concluido') return 'Concluído';
    if (status === 'execução' || status === 'execucao') return 'Execução';
    return 'Aguardando';
  }

  getContratosPorFase() {
    const { procedimentosLista } = this.state;
    const fases = {};
    const fasesAtrasados = {};
    GRUPOS_MACRO.forEach(g => { fases[g.grupo] = new Set(); fasesAtrasados[g.grupo] = new Set(); });

    procedimentosLista.forEach(p => {
      if (this.isAbandonado(p)) return;
      const fase = classificarEtapa(p.procedimento);
      if (!fase || !fases[fase]) return;
      fases[fase].add(p.codContrato);
      if (p.atrasado) fasesAtrasados[fase].add(p.codContrato);
    });

    return GRUPOS_MACRO.map(g => ({
      grupo: g.grupo,
      icone: g.icone,
      cor: g.cor,
      total: fases[g.grupo].size,
      atrasados: fasesAtrasados[g.grupo].size
    }));
  }

  getDistribuicaoContratosUnicos() {
    const { procedimentosLista } = this.state;
    const ordemFase = {};
    GRUPOS_MACRO.forEach((g, idx) => { ordemFase[g.grupo] = idx; });

    const porContrato = {};
    procedimentosLista.forEach((p) => {
      if (this.isAbandonado(p) || !p.codContrato) return;
      const fase = classificarEtapa(p.procedimento);
      if (!fase) return;
      const ordem = ordemFase[fase] != null ? ordemFase[fase] : -1;
      const atual = porContrato[p.codContrato];

      // Mantem o contrato apenas na fase mais avancada para evitar duplicidade entre fases.
      if (!atual || ordem > atual.ordem) {
        porContrato[p.codContrato] = { fase, ordem };
      }
    });

    const contagem = {};
    GRUPOS_MACRO.forEach((g) => { contagem[g.grupo] = 0; });

    Object.values(porContrato).forEach(({ fase }) => {
      contagem[fase] = (contagem[fase] || 0) + 1;
    });

    const fases = GRUPOS_MACRO.map((g) => ({
      grupo: g.grupo,
      icone: g.icone,
      cor: g.cor,
      total: contagem[g.grupo] || 0
    }));

    return {
      fases,
      totalContratos: Object.keys(porContrato).length
    };
  }

  abrirDetalheFase(fase) {
    const { procedimentosLista } = this.state;

    // Filtra procedimentos que pertencem a essa fase (ignora não classificados)
    const procDaFase = procedimentosLista.filter(
      p => {
        const f = classificarEtapa(p.procedimento);
        return f === fase && !this.isAbandonado(p);
      }
    );

    // Agrupa por contrato (distinct) — pega o primeiro procedimento de cada contrato como representante
    const contratosMap = {};
    procDaFase.forEach(p => {
      if (!contratosMap[p.codContrato]) {
        contratosMap[p.codContrato] = {
          Codigo: p.codContrato,
          contrato: p.contrato,
          procedimento: p.procedimento,
          dtfim: p.dtfim,
          Resp: p.Resp,
          statusProc: p.statusProc,
          atrasado: p.atrasado
        };
      }
    });

    const contratos = Object.values(contratosMap);
    // Atrasados primeiro, depois por prazo crescente
    contratos.sort((a, b) => {
      const atrasoDiff = (b.atrasado ? 1 : 0) - (a.atrasado ? 1 : 0);
      if (atrasoDiff !== 0) return atrasoDiff;
      if (!a.dtfim && !b.dtfim) return 0;
      if (!a.dtfim) return 1;
      if (!b.dtfim) return -1;
      return new Date(a.dtfim) - new Date(b.dtfim);
    });

    this.setState({
      detalheAberto: true,
      detalheLoading: false,
      detalheTipo: 'fase',
      detalheProcedimento: fase,
      detalheContratos: contratos,
      detalhePagina: 1,
      filtros: { contrato: '', procedimento: '', atendente: '', entregaDe: '', formaturaDe: '' }
    });
  }

  getBarChartData() {
    const { procedimentos } = this.state;
    const procMap = {};
    procedimentos.forEach(p => { procMap[p.procedimento] = p; });
    const labels = [];
    const totais = [];
    const atrasados = [];
    const cores = [];
    this.state.pipeline.forEach(grupo => {
      let total = 0;
      let atraso = 0;
      grupo.etapas.forEach(etapa => {
        if (procMap[etapa]) {
          total += procMap[etapa].total || 0;
          atraso += procMap[etapa].atrasados || 0;
        }
      });
      labels.push(grupo.grupo);
      totais.push(total);
      atrasados.push(atraso);
      cores.push(grupo.cor);
    });
    return {
      labels,
      datasets: [
        { label: 'No Prazo', data: totais.map((t, i) => t - atrasados[i]), backgroundColor: cores.map(c => c + 'CC'), borderColor: cores, borderWidth: 1 },
        { label: 'Atrasados', data: atrasados, backgroundColor: '#dd4b39CC', borderColor: '#dd4b39', borderWidth: 1 }
      ]
    };
  }

  contarFiltrosAtivos() {
    let count = 0;
    if (this.state.filtroDesigner) count++;
    if (this.state.filtroFormaturaDe) count++;
    if (this.state.filtroFormaturaAte) count++;
    if (this.state.filtroProcedimento) count++;
    if (this.state.filtroStatus !== 'todos') count++;
    if (this.state.dataInicio !== '2021-01-01') count++;
    return count;
  }

  renderTimeline() {
    const { timelineAberto, timelineLoading, timelineContrato, timelineProcedimentos, timelineRefeito } = this.state;

    const getStatusInfo = (proc) => {
      const status = (proc.Status || '').toLowerCase();
      if (proc.atrasado) return { class: 'tl-item--atrasado', label: 'Atrasado', icon: 'fa-exclamation-circle' };
      if (status === 'concluido') return { class: 'tl-item--concluido', label: 'Concluído', icon: 'fa-check-circle' };
      if (status === 'execução' || status === 'execucao') return { class: 'tl-item--execucao', label: 'Execução', icon: 'fa-play-circle' };
      return { class: 'tl-item--aguardando', label: 'Aguardando', icon: 'fa-clock-o' };
    };

    return (
      <Modal
        title={
          <div className="tl-modal-header">
            <i className="fa fa-calendar-check-o tl-modal-icon" />
            <span>Cronograma</span>
            {timelineContrato && <span className="tl-modal-contrato">{timelineContrato.contrato}</span>}
          </div>
        }
        visible={timelineAberto}
        onCancel={() => this.fecharTimeline()}
        footer={null}
        width={650}
        className="db-modal-timeline"
        zIndex={1010}
        bodyStyle={{ padding: 0 }}
      >
        {timelineContrato && (
          <div className="tl-info-bar">
            <div className="tl-info-item">
              <i className="fa fa-user" />
              <span>{timelineContrato.RegistradoPor || '-'}</span>
            </div>
            <div className="tl-info-item">
              <i className="fa fa-truck" />
              <span>{timelineContrato.dt_entrega ? moment(timelineContrato.dt_entrega).format('DD/MM/YYYY') : '-'}</span>
            </div>
            <div className="tl-info-item">
              <i className="fa fa-graduation-cap" />
              <span>{timelineContrato.dt_formatura ? moment(timelineContrato.dt_formatura).format('DD/MM/YYYY') : '-'}</span>
            </div>
            {timelineRefeito && timelineRefeito.totalVezes > 0 && (
              <div className="tl-info-refeito">
                <i className="fa fa-refresh" />
                <span>{timelineRefeito.totalVezes}x refeito</span>
                <span className="tl-refeito-detail">({timelineRefeito.refeitoAlpha || 0} Alpha, {timelineRefeito.refeitoCliente || 0} Cliente)</span>
              </div>
            )}
          </div>
        )}

        <div className="tl-body">
          {timelineLoading ? (
            <div style={{ padding: 60, textAlign: 'center' }}><Spin size="large" /></div>
          ) : (
            <div className="tl-list">
              {timelineProcedimentos.map((proc, i) => {
                const statusInfo = getStatusInfo(proc);
                return (
                  <div key={i} className={`tl-item ${statusInfo.class}`}>
                    <div className="tl-item-line">
                      <div className="tl-item-dot">
                        <i className={`fa ${statusInfo.icon}`} />
                      </div>
                    </div>
                    <div className="tl-item-content">
                      <div className="tl-item-header">
                        <span className="tl-item-index">{proc.nIndex}</span>
                        <span className="tl-item-nome">{proc.procedimento}</span>
                        <span className={`tl-item-status tl-status--${statusInfo.class.replace('tl-item--', '')}`}>{statusInfo.label}</span>
                      </div>
                      <div className="tl-item-meta">
                        {proc.dtini && <span><i className="fa fa-calendar" /> {moment(proc.dtini).format('DD/MM/YYYY')}</span>}
                        {proc.dtfim && <span><i className="fa fa-flag" /> {moment(proc.dtfim).format('DD/MM/YYYY')}</span>}
                        {proc.Resp && <span><i className="fa fa-user-o" /> {proc.Resp}</span>}
                      </div>
                      <button className="tl-item-comment" onClick={() => this.abrirComentario(proc)}>
                        <i className="fa fa-comment-o" /> Comentar
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </Modal>
    );
  }

  renderComentario() {
    const { comentarioAberto, comentarioLoading, comentarioProc, novoComentario, salvandoComentario, timelineContrato, comentarios } = this.state;

    return (
      <Modal
        title="Comentários do Procedimento"
        visible={comentarioAberto}
        onCancel={() => this.fecharComentario()}
        footer={null}
        width={600}
        zIndex={1020}
      >
        {comentarioProc && (
          <div style={{ marginBottom: 15, padding: 10, background: '#f9f9f9', borderRadius: 4 }}>
            <Text strong>{comentarioProc.procedimento}</Text><br />
            <Text type="secondary" style={{ fontSize: 12 }}>Registro: {comentarioProc.Registro} | Contrato: {timelineContrato ? timelineContrato.contrato : ''}</Text>
          </div>
        )}

        <div style={{ marginBottom: 15 }}>
          <Input.TextArea
            rows={3}
            placeholder="Digite seu comentário..."
            value={novoComentario}
            onChange={(e) => this.setState({ novoComentario: e.target.value })}
          />
          <div style={{ textAlign: 'right', marginTop: 8 }}>
            <Button type="primary" onClick={() => this.salvarComentario()} loading={salvandoComentario} disabled={!novoComentario.trim()}>
              Postar
            </Button>
          </div>
        </div>

        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
          <Text strong>Histórico</Text>
          {comentarioLoading ? (
            <div className="text-center" style={{ padding: 20 }}><Spin /></div>
          ) : (
            <List
              itemLayout="horizontal"
              dataSource={comentarios}
              locale={{ emptyText: 'Nenhum comentário registrado.' }}
              renderItem={item => (
                <List.Item>
                  <List.Item.Meta
                    avatar={<Avatar icon={<i className="fa fa-user" />} />}
                    title={<div style={{ display: 'flex', justifyContent: 'space-between' }}><Text strong>{item.usuario || 'Usuário'}</Text> <Text type="secondary" style={{ fontSize: 11 }}>{item.data ? moment(item.data).format('DD/MM/YYYY HH:mm') : ''}</Text></div>}
                    description={item.comentario}
                  />
                </List.Item>
              )}
            />
          )}
        </div>
      </Modal>
    );
  }

  renderTabelasProcedimentos() {
    const { procedimentosLista, filtroStatus } = this.state;
    const ordenarAtrasadosPrimeiro = (a, b) => {
      const atrasoDiff = (b.atrasado ? 1 : 0) - (a.atrasado ? 1 : 0);
      if (atrasoDiff !== 0) return atrasoDiff;
      if (!a.dtfim && !b.dtfim) return 0;
      if (!a.dtfim) return 1;
      if (!b.dtfim) return -1;
      return new Date(a.dtfim) - new Date(b.dtfim);
    };

    // Separar por Resp: "Cliente" vs restante (Alpha/designers)
    const listaFiltrada = procedimentosLista.filter(p => {
      if (this.isAbandonado(p)) return false;
      if (filtroStatus === 'atrasado') return !!p.atrasado;
      if (filtroStatus === 'prazo') return !p.atrasado;
      return true;
    });

    const procCliente = listaFiltrada
      .filter(p => (p.Resp || '').toLowerCase() === 'cliente')
      .sort(ordenarAtrasadosPrimeiro);
    const procAlpha = listaFiltrada
      .filter(p => (p.Resp || '').toLowerCase() !== 'cliente')
      .sort(ordenarAtrasadosPrimeiro);
    const atrasadosCliente = procCliente.filter(p => p.atrasado).length;
    const atrasadosAlpha = procAlpha.filter(p => p.atrasado).length;

    const colunas = (isAlpha) => [
      {
        title: 'Contrato', dataIndex: 'codContrato', key: 'codContrato', width: 110,
        render: (text, record) => (
          <span className="db-table-contrato" onClick={() => this.abrirTimeline(record.codContrato)}>
            {record.contrato || text}
          </span>
        )
      },
      {
        title: 'Procedimento', dataIndex: 'procedimento', key: 'procedimento',
        ellipsis: true,
        render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>
      },
      {
        title: 'Data fim', dataIndex: 'dtfim', key: 'dtfim', width: 110, align: 'center',
        render: (txt, record) => {
          if (!txt) return '-';
          const formatted = moment(txt).format('DD/MM/YYYY');
          return <span className={record.atrasado ? 'db-date--atrasado' : ''}>{formatted}</span>;
        },
        sorter: (a, b) => {
          if (!a.dtfim) return 1;
          if (!b.dtfim) return -1;
          return new Date(a.dtfim) - new Date(b.dtfim);
        }
      },
      {
        title: isAlpha ? 'Responsável' : 'Responsável', dataIndex: 'Resp', key: 'Resp', width: 120,
        render: (text) => <span style={{ fontWeight: 600 }}>{text || '-'}</span>
      }
    ];

    const getRowClass = (record) => {
      if (record.atrasado) return 'db-proc-row--atrasado';
      return '';
    };

    return (
      <Row gutter={16} className="db-proc-tables">
        <Col xs={24} lg={12}>
          <Card
            className="db-proc-card"
            title={
              <div className="db-proc-card-title">
                <i className="fa fa-users" style={{ color: '#f59e0b' }} />
                <span>Procedimentos Cliente</span>
                <Badge count={procCliente.length} style={{ backgroundColor: '#f59e0b' }} overflowCount={999} />
                {atrasadosCliente > 0 && (
                  <span className="db-kpi-atrasados">
                    <i className="fa fa-exclamation-circle" /> {atrasadosCliente} atrasado{atrasadosCliente > 1 ? 's' : ''}
                  </span>
                )}
              </div>
            }
            bodyStyle={{ padding: 0 }}
          >
            <Table
              dataSource={procCliente}
              columns={colunas(false)}
              rowKey={(r, i) => `cli-${r.codContrato}-${r.procedimento}-${i}`}
              size="small"
              className="db-proc-table"
              rowClassName={getRowClass}
              pagination={false}
              scroll={{ x: 500, y: 500 }}
            />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card
            className="db-proc-card"
            title={
              <div className="db-proc-card-title">
                <i className="fa fa-building" style={{ color: '#3b82f6' }} />
                <span>Procedimentos Alpha</span>
                <Badge count={procAlpha.length} style={{ backgroundColor: '#3b82f6' }} overflowCount={999} />
                {atrasadosAlpha > 0 && (
                  <span className="db-kpi-atrasados">
                    <i className="fa fa-exclamation-circle" /> {atrasadosAlpha} atrasado{atrasadosAlpha > 1 ? 's' : ''}
                  </span>
                )}
              </div>
            }
            bodyStyle={{ padding: 0 }}
          >
            <Table
              dataSource={procAlpha}
              columns={colunas(true)}
              rowKey={(r, i) => `alpha-${r.codContrato}-${r.procedimento}-${i}`}
              size="small"
              className="db-proc-table"
              rowClassName={getRowClass}
              pagination={false}
              scroll={{ x: 500, y: 500 }}
            />
          </Card>
        </Col>
      </Row>
    );
  }

  renderDetalhe() {
    const { detalheAberto, detalheLoading, detalheProcedimento, detalheTipo, filtros } = this.state;
    const filtrados = this.filtrarContratos()
      .filter((c) => {
        if (this.state.filtroStatus === 'atrasado') return !!c.atrasado;
        if (this.state.filtroStatus === 'prazo') return !c.atrasado;
        return true;
      })
      .sort((a, b) => (b.atrasado ? 1 : 0) - (a.atrasado ? 1 : 0));

    const colunaContrato = {
      title: 'Contrato', dataIndex: 'contrato', key: 'contrato', width: 140,
      render: (text, record) => (
        <span className="db-table-contrato" onClick={() => this.abrirTimeline(record.Codigo)}>
          {text || record.Codigo}
        </span>
      ),
      filterDropdown: () => (
        <div style={{ padding: 8 }}>
          <Input placeholder="Buscar contrato" value={filtros.contrato} onChange={e => this.atualizarFiltro('contrato', e.target.value)} style={{ width: 188 }} />
        </div>
      ),
      filterIcon: () => <i className="fa fa-search" style={{ color: filtros.contrato ? '#dc2626' : '#a0aec0' }} />
    };

    const colunaStatus = {
      title: 'Status', key: 'status', width: 100, align: 'center',
      render: (_, record) => {
        const status = (record.statusProc || '').toLowerCase();
        if (record.atrasado) return <span className="db-status db-status--atrasado">Atrasado</span>;
        if (status === 'execução' || status === 'execucao') return <span className="db-status db-status--execucao">Execução</span>;
        if (status === 'concluido') return <span className="db-status db-status--concluido">Concluído</span>;
        return <span className="db-status db-status--aguardando">Aguardando</span>;
      }
    };

    const colunaPrazo = {
      title: 'Prazo', dataIndex: 'dtfim', key: 'dtfim', width: 120, align: 'center',
      render: (txt, record) => {
        const formatted = txt ? moment(txt).format('DD/MM/YYYY') : '-';
        return <span className={record.atrasado ? 'db-date--atrasado' : ''} style={{ whiteSpace: 'nowrap' }}>{formatted}</span>;
      }
    };

    let columns;
    if (detalheTipo === 'fase') {
      columns = [
        colunaContrato,
        {
          title: 'Procedimento', dataIndex: 'procedimento', key: 'procedimento',
          ellipsis: true,
          render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>
        },
        {
          title: 'Responsável', dataIndex: 'Resp', key: 'Resp', width: 120,
          render: (text) => <span style={{ fontWeight: 600 }}>{text || '-'}</span>
        },
        colunaStatus,
        colunaPrazo
      ];
    } else {
      columns = [
        colunaContrato,
        {
          title: 'Atendente', dataIndex: 'RegistradoPor', key: 'RegistradoPor', width: 140,
          filterDropdown: () => (
            <div style={{ padding: 8 }}>
              <Input placeholder="Buscar atendente" value={filtros.atendente} onChange={e => this.atualizarFiltro('atendente', e.target.value)} style={{ width: 188 }} />
            </div>
          ),
          filterIcon: () => <i className="fa fa-filter" style={{ color: filtros.atendente ? '#dc2626' : '#a0aec0' }} />
        },
        colunaStatus,
        colunaPrazo,
        {
          title: 'Entrega', dataIndex: 'dt_entrega', key: 'dt_entrega', width: 100, align: 'center',
          render: txt => txt ? moment(txt).format('DD/MM/YYYY') : '-'
        },
        {
          title: 'Formatura', dataIndex: 'dt_formatura', key: 'dt_formatura', width: 100, align: 'center',
          render: txt => txt ? moment(txt).format('DD/MM/YYYY') : '-'
        },
      ];
    }

    return (
      <Modal
        title={
          <div className="db-modal-header">
            <span className="db-modal-title">{detalheProcedimento}</span>
            <span className="db-modal-count">{filtrados.length} contratos</span>
          </div>
        }
        visible={detalheAberto}
        onCancel={() => this.fecharDetalhe()}
        width={900}
        className="db-modal-detalhe"
        footer={null}
        bodyStyle={{ padding: 0 }}
      >
        {detalheLoading ? (
          <div style={{ padding: 60, textAlign: 'center' }}><Spin size="large" /></div>
        ) : (
          <React.Fragment>
            {detalheTipo === 'fase' && (
              <div className="db-modal-filters">
                <Input
                  allowClear
                  className="db-modal-filter-input"
                  placeholder="Filtrar procedimento..."
                  value={filtros.procedimento}
                  onChange={e => this.atualizarFiltro('procedimento', e.target.value)}
                  prefix={<i className="fa fa-search" style={{ color: '#94a3b8' }} />}
                />
              </div>
            )}
            <Table
              dataSource={filtrados}
              columns={columns}
              rowKey="Codigo"
              size="middle"
              className="db-table"
              pagination={{
                pageSize: 10,
                showSizeChanger: false,
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total}`,
                size: 'small'
              }}
              rowClassName={(record) => record.atrasado ? 'db-table-row--atrasado' : ''}
            />
          </React.Fragment>
        )}
      </Modal>
    );
  }

  render() {
    const { procedimentos, loading, filtroStatus, atendentes, buscaContrato, dataInicio, filtroFormaturaAte, filtroDesigner } = this.state;
    const usuario = this.props.usuario;

    if (usuario && usuario.tipo !== 'administrador') {
      return (
        <Row style={{ padding: 20 }}>
          <Col span={10}><Notificacoes altura={500} /></Col>
        </Row>
      );
    }

    const fases = this.getContratosPorFase();
    const procMap = {};
    procedimentos.forEach(p => { procMap[p.procedimento] = p; });

    const distribuicaoUnica = this.getDistribuicaoContratosUnicos();
    const fasesDistribuicao = distribuicaoUnica.fases;

    const doughnutData = {
      labels: fasesDistribuicao.map(f => f.grupo),
      datasets: [{
        data: fasesDistribuicao.map(f => f.total),
        backgroundColor: fasesDistribuicao.map(f => f.cor),
        borderWidth: 0
      }]
    };
    const doughnutOpts = { cutoutPercentage: 70, legend: { display: false }, tooltips: { enabled: true }, maintainAspectRatio: false };
    const totalContratos = distribuicaoUnica.totalContratos;

    const barData = this.getBarChartData();
    const barOpts = {
      legend: { position: 'bottom', labels: { fontSize: 11 } },
      scales: { yAxes: [{ ticks: { beginAtZero: true } }], xAxes: [{ ticks: { fontSize: 11 } }] },
      maintainAspectRatio: false
    };

    return (
      <div className="db-page">
        <div className="db-topbar">
          <Input.Search
            className="db-topbar-search"
            placeholder="Buscar contrato..."
            onSearch={() => this.buscarContrato()}
            value={buscaContrato}
            onChange={e => this.setState({ buscaContrato: e.target.value })}
            enterButton
            loading={this.state.buscandoContrato}
            style={{ maxWidth: 320 }}
          />
        </div>

        <Card className="db-filters-card" bodyStyle={{ padding: 16 }}>
          <div className="db-filters-grid">
            <div className="filter-item">
              <Text className="filter-item-label">Cadastro</Text>
              <Input type="date" value={dataInicio} onChange={e => this.setState({ dataInicio: e.target.value })} size="small" />
            </div>

            <div className="filter-item">
              <Text className="filter-item-label">Formatura Até</Text>
              <Input type="date" value={filtroFormaturaAte} onChange={e => this.setState({ filtroFormaturaAte: e.target.value })} size="small" />
            </div>

            <div className="filter-item">
              <Text className="filter-item-label">Designer</Text>
              <Select value={filtroDesigner} onChange={v => this.setState({ filtroDesigner: v })} size="small">
                <Option value="">Todos</Option>
                {atendentes.map(d => <Option key={d} value={d}>{d}</Option>)}
              </Select>
            </div>

            <div className="filter-item">
              <Text className="filter-item-label">Status</Text>
              <Select value={filtroStatus} onChange={v => this.setState({ filtroStatus: v })} size="small">
                <Option value="todos">Todos</Option>
                <Option value="prazo">No Prazo</Option>
                <Option value="atrasado">Atrasados</Option>
              </Select>
            </div>

            <div className="filter-item filter-actions">
              <Button type="primary" onClick={() => this.aplicarFiltros()} size="small" icon={<FilterOutlined />}>Filtrar</Button>
              {this.contarFiltrosAtivos() > 0 && (
                <Button type="default" onClick={() => this.limparFiltros()} size="small" icon={<ClearOutlined />}>
                  Limpar
                </Button>
              )}
            </div>
          </div>
        </Card>

        <div className="db-kpi-grid db-kpi-grid--fases">
          {fases.map((fase, i) => (
            <div key={i} className={`db-kpi-card db-kpi-card--clickable${fase.atrasados > 0 ? ' db-kpi-card--atrasado' : ''}`} style={{ '--kpi-accent': fase.cor }} onClick={() => this.abrirDetalheFase(fase.grupo)}>
              <Statistic
                title={fase.grupo}
                value={fase.total}
                valueStyle={{ color: fase.cor }}
                prefix={<i className={`fa ${fase.icone}`} style={{ color: fase.cor }} />}
              />
              <div className="db-kpi-foot">
                procedimentos nesta fase
                {' '}
                {fase.atrasados > 0 && (
                  <span className="db-kpi-atrasados">
                    <i className="fa fa-exclamation-circle" /> {fase.atrasados} atrasado{fase.atrasados > 1 ? 's' : ''}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 50 }}><Spin size="large" tip="Carregando dados..." /></div>
        ) : (
          <React.Fragment>
            {/* TABELAS DE PROCEDIMENTOS */}
            {this.renderTabelasProcedimentos()}

            {/* CHARTS */}
            <div className="db-section-header">
              <Title level={4} className="db-section-title">Análises gerais</Title>
              <Text type="secondary">Visão comparativa por fase e status geral</Text>
            </div>
            <Row gutter={20} className="db-charts-row">
              <Col xs={24} md={16}>
                <Card title="Contratos por Fase" className="db-chart-card">
                  <div className="db-chart-body">
                    <Bar data={barData} options={barOpts} />
                  </div>
                </Card>
              </Col>
              <Col xs={24} md={8}>
                <Card title="Distribuição por Fase" className="db-chart-card">
                  <div className="db-chart-body db-chart-doughnut">
                    <Doughnut data={doughnutData} options={doughnutOpts} />
                    <div className="db-chart-center">
                      <div className="db-chart-percent" style={{ color: 'var(--db-ink)' }}>{totalContratos}</div>
                      <div className="db-chart-label">contratos</div>
                    </div>
                  </div>
                  <div className="db-chart-legend">
                    <Space size="small" wrap>
                      {fasesDistribuicao.map((f, i) => (
                        <span key={i}><Badge color={f.cor} /> {f.grupo}: <strong>{f.total}</strong></span>
                      ))}
                    </Space>
                  </div>
                </Card>
              </Col>
            </Row>
          </React.Fragment>
        )}

        {this.renderDetalhe()}
        {this.renderTimeline()}
        {this.renderComentario()}
      </div>
    );
  }


}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
  }
}

export default connect(mapStateToProps, {})(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/index.js